module.exports = __webpack_public_path__ + "static/icon_dt.3597c045.png";